module.exports = __webpack_public_path__ + "files/06c27161d8dccc1af765f3d8fbe9b376.png";